/* Native page scrolling drives the opted-in home carousels. */
if(!customElements.get('tz-scroll-carousel'))customElements.define('tz-scroll-carousel',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('[data-carnav-track]');this.sticky=this.firstElementChild;this.follow=this.closest(".shopify-section")?.nextElementSibling;
  if(!this.track)return;
  this.reduce=matchMedia('(prefers-reduced-motion:reduce)');
  this.measure=()=>{
   this.max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
   this.top=matchMedia('(max-width:749px)').matches?88:100;
   this.toggleAttribute('data-story',!this.reduce.matches&&this.max>4);
   this.travel=Math.max(280,this.max*.65);
   this.syncFollow(this.hasAttribute("data-story"));
   this.style.setProperty('--story-top',this.top+'px');
   this.style.setProperty('--story-height',(this.sticky.offsetHeight+this.travel)+'px');
   this.schedule();
  };
  this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.render();});};
  window.addEventListener('scroll',this.schedule,{signal,passive:true});
  this.width=this.clientWidth;
  this.resize=new ResizeObserver(()=>{if(this.width!==this.clientWidth){this.width=this.clientWidth;this.measure();}});this.resize.observe(this);
  this.contentResize=new ResizeObserver(this.measure);this.contentResize.observe(this.sticky);
  this.reduce.addEventListener('change',this.measure,{signal});
  this.querySelector('[data-story-skip]').addEventListener('click',()=>window.scrollTo({top:scrollY+this.getBoundingClientRect().bottom-this.top,behavior:'smooth'}),{signal});
  for(const [selector,dir] of [['[data-carnav-prev]',-1],['[data-carnav-next]',1]])this.querySelector(selector)?.addEventListener('click',e=>{
   if(!this.hasAttribute('data-story'))return;
   e.preventDefault();e.stopImmediatePropagation();
   const card=this.track.querySelector('.carnav__item');
   const step=card.offsetWidth+(parseFloat(getComputedStyle(this.track).columnGap)||0);
   const left=Math.max(0,Math.min(this.max,this.track.scrollLeft+step*dir));
   window.scrollTo({top:scrollY+this.getBoundingClientRect().top-this.top+left/this.max*this.travel,behavior:'smooth'});
  },{signal,capture:true});
  this.measure();
 }
 render(){
  if(!this.hasAttribute('data-story'))return;
  const r=this.getBoundingClientRect(),p=Math.max(0,Math.min(1,(this.top-r.top)/this.travel));
  this.follow?.toggleAttribute('data-carousel-preview',p<1);
  if(r.bottom>=0&&r.top<innerHeight)this.track.scrollLeft=p*this.max;
 }
 syncFollow(active){
  if(!this.follow)return;
  if(active&&!this.followSlot){
   // Keep the real next section attached to the native sticky surface. Its
   // placeholder preserves document flow; no per-scroll section transform.
   this.followSlot=document.createElement('div');this.followSlot.className='tz-carousel-follow-space';this.followSlot.setAttribute('aria-hidden','true');
   this.follow.before(this.followSlot);
   this.follow.classList.add('tz-carousel-follow');this.sticky.append(this.follow);
   this.followResize=new ResizeObserver(()=>this.followSlot?.style.setProperty('height',this.follow.offsetHeight+'px'));
   this.followResize.observe(this.follow);this.followSlot.style.height=this.follow.offsetHeight+'px';
  }else if(!active&&this.followSlot){
   this.followResize?.disconnect();this.follow.classList.remove('tz-carousel-follow');this.follow.removeAttribute('data-carousel-preview');
   this.followSlot.replaceWith(this.follow);this.followSlot=null;
  }
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.contentResize?.disconnect();cancelAnimationFrame(this.frame);this.syncFollow(false);}
});

if(!customElements.get('tz-mobile-testimonials'))customElements.define('tz-mobile-testimonials',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;
  this.cards=[...this.querySelectorAll('.testimonial')];this.track=this.querySelector('.reveal-testimonials');
  this.mobile=matchMedia('(max-width:767px)');this.reduce=matchMedia('(prefers-reduced-motion:reduce)');
  this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.render();});};
  this.mobile.addEventListener('change',this.schedule,{signal});this.reduce.addEventListener('change',this.schedule,{signal});
  window.addEventListener('scroll',this.schedule,{signal,passive:true});
  this.resize=new ResizeObserver(this.schedule);this.resize.observe(this);this.schedule();
 }
 render(){
  const active=this.mobile.matches&&!this.reduce.matches;
  const bounds=this.track.getBoundingClientRect();
  if(active&&(bounds.top>innerHeight+100||bounds.bottom< -100))return;
  const viewport=document.documentElement.clientHeight;
  this.cards.forEach((card,i)=>{
   if(!active){card.style.removeProperty('--review-shift');card.style.removeProperty('--review-shift-x');return;}
   const top=bounds.top+card.offsetTop;
   const progress=Math.max(0,Math.min(1,(viewport-top)/(viewport*.58)));
   const remaining=1-progress*progress*(3-2*progress);
   card.style.setProperty('--review-shift',`${(remaining*88).toFixed(2)}px`);
   card.style.setProperty('--review-shift-x',`${(remaining*(i%2?-16:16)).toFixed(2)}px`);
  });
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
});


